import { axiosClient } from "../client";

const queryString = require("query-string");

const REWARD_REDEMPTION_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/dashboard/reward-redemption`;

const REWARD_CHOICES_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/dashboard/reward-choices`;

const REWARD_COST_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/dashboard/reward-cost`;

export const fetchAllRewardRedemptionInfo = (
  token,
  locationId,
  filterData,
  programId,
) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: REWARD_REDEMPTION_GET_ALL(locationId),
        query: { where: filterData, program_id: programId },
      },
      {
        sort: false,
        arrayFormat: "comma",
        skipNull: true,
        skipEmptyString: true,
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

export const fetchAllRewardChoicesInfo = (
  token,
  locationId,
  filterData,
) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: REWARD_CHOICES_GET_ALL(locationId),
        query: { where: filterData },
      },
      {
        sort: false,
        arrayFormat: "comma",
        skipNull: true,
        skipEmptyString: true,
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  export const fetchAllRewardCostInfo = (
  token,
  locationId,
  filterData,
  programId,
) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: REWARD_COST_GET_ALL(locationId),
        query: { where: filterData, program_id: programId },
      },
      {
        sort: false,
        arrayFormat: "comma",
        skipNull: true,
        skipEmptyString: true,
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
